import { Reducer } from "redux";
import {
  FETCH_DEPARTMENT_REQUEST,
  FETCH_DEPARTMENT_SUCCESS,
  FETCH_DEPARTMENT_FAILURE,
  VIEW_DEPARTMENT_REQUEST,
  VIEW_DEPARTMENT_SUCCESS,
  VIEW_DEPARTMENT_FAILURE,
  DepartmentActionTypes,
  RESET_DEPARTMENT_DETAILS,
} from "../actions/departmentActions";

interface DepartmentState {
  departments: any[];
  departmentDetails: any | null;
  totalCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DepartmentState = {
  departments: [],
  departmentDetails: null,
  totalCount: 0,
  loading: false,
  error: null,
};

const departmentsReducer = (
  state = initialState,
  action: DepartmentActionTypes
): DepartmentState => {
  switch (action.type) {
    case FETCH_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        departments: action.payload.data,
        totalCount: action.payload.total,
      };

    case FETCH_DEPARTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case VIEW_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case VIEW_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        departmentDetails: action.payload.data,
        totalCount: action.payload.total,
      };

    case VIEW_DEPARTMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case RESET_DEPARTMENT_DETAILS:
      return {
        ...state,
        departmentDetails: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

// Redux 5 types actions as UnknownAction; cast keeps internal narrowing intact
export default departmentsReducer as Reducer<DepartmentState>;